import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/index.scss';
import QuestionnaireProvider from '../providers/QuestionnaireProvider';

const App = ({ children }: { children: React.ReactNode }) => {

  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // eslint-disable-next-line
  }, [location]);

  return (
    <React.Fragment>
      <div className="imm_quest_admin__app">
        <QuestionnaireProvider>
          {children}
          <ToastContainer toastStyle={{ fontFamily: 'Poppins', fontSize: '14px' }} autoClose={2000} />
        </QuestionnaireProvider>
      </div>
    </React.Fragment>
  );
};

export default App;